<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-alert
        v-if="errorMsg"
        variant="warning"
        show
      >
        <div class="alert-body">
          <span>{{ errorMsg }}</span>
        </div>
      </b-alert>
      <div
        :class="items.length > 1 ? 'scroll-div' : ''"
      >
        <b-form
          ref="form"
          class="repeater-form"
          @submit.prevent="repeateAgain"
        >

          <!-- Row Loop -->
          <b-row
            v-for="(item, index) in items"
            :id="index"
            :key="index"
            ref="row"
            class="px-1"
          >

            <!-- Remove Button -->
            <b-col
              v-if="index > 0"
              md="12"
              class="p-0"
            >
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-danger"
                class="mt-0 mt-md-2 float-right mr-1"
                @click="removeItem(index)"
              >
                Delete Record
              </b-button>
            </b-col>
            <!-- Item Name -->
            <b-col
              md="6"
              class="pt-0 pl-1 pr-1"
            >
              <b-form-group
                :label="$t('DEBTIA_FILE')+'*'"
                label-for="item-name"
              >
                <b-form-file
                  :id="'file-default-'+item.recordIndex"
                  v-model="item.file"
                  :class="'file-default-'+item.recordIndex"
                />
              </b-form-group>
            </b-col>

            <!-- Quantity -->
            <b-col
              md="6"
              class="pt-0 pl-1 pr-1"
            >
              <b-form-group
                :label="$t('DEBTIA_TITLE')+'*'"
                label-for="title"
              >
                <b-form-input
                  :id="'title-'+index"
                  v-model="item.title"
                  type="text"
                  :placeholder="$t('DEBTIA_TITLE')"
                  @change="otherFileFieldChanged('title', index)"
                />
              </b-form-group>
            </b-col>

            <b-col
              sm="6"
              class="mb-1"
            >
              <b-input-group
                :prepend="$t('DEBTIA_SENT_AT')+'*'"
              >
                <cleave
                  id="date"
                  v-model="item.daSentAt"
                  class="form-control"
                  :raw="false"
                  :options="options.date"
                  placeholder="DD-MM-YYYY"
                  @input="validateDate('senddateerror', item.recordIndex, item, 'daSentAt', 'sentAt'), dueDateValidity(item.recordIndex, item)"
                />
                <b-input-group-append>
                  <b-form-datepicker
                    v-model="item.sentAt"
                    :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
                    trim
                    button-only
                    right
                    size="sm"
                    @input="assignDateValue($event, item, 'daSentAt'), dueDateValidity(item.recordIndex, item)"
                  />
                </b-input-group-append>
              </b-input-group>
              <label
                :id="'senddateerror-'+item.recordIndex"
                style="color: red; display:none;"
              >*{{ $t('DEBTIA_DATE_FORMAT_ERROR') }}</label>
            </b-col>

            <b-col
              sm="6"
              class="mb-1"
            >
              <b-input-group
                :prepend="$t('DEBTIA_DUE_DATE')+'*'"
              >
                <cleave
                  id="date"
                  v-model="item.daDueDate"
                  class="form-control"
                  :raw="false"
                  :options="options.date"
                  placeholder="DD-MM-YYYY"
                  @input="validateDate('duedateerror', item.recordIndex, item, 'daDueDate', 'dueDate'), dueDateValidity(item.recordIndex, item)"
                />
                <b-input-group-append>
                  <b-form-datepicker
                    v-model="item.dueDate"
                    :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
                    trim
                    button-only
                    right
                    size="sm"
                    @input="assignDateValue($event, item, 'daDueDate'), dueDateValidity(item.recordIndex, item)"
                  />
                </b-input-group-append>
              </b-input-group>
              <label
                :id="'datecomparisonerror-'+item.recordIndex"
                style="color: red; display:none;"
              >*{{ $t('DEBTIA_DUEDATE_LESSER_ERROR') }}</label>
              <label
                :id="'duedateerror-'+item.recordIndex"
                style="color: red; display:none;"
              >*{{ $t('DEBTIA_DATE_FORMAT_ERROR') }}</label>
            </b-col>

            <b-col
              md="6"
              class="pt-0 pl-1 pr-1"
            >
              <b-form-group
                :label="$t('DEBTIA_PAYMENT_AMOUNT')+'*'"
                label-for="item-name"
              >
                <b-input-group append="kr.">
                  <b-form-input
                    :id="'title-'+index"
                    v-model="item.paymentAmount"
                    type="number"
                    :placeholder="$t('DEBTIA_AMOUNT')"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>

            <!-- Quantity -->
            <b-col
              md="6"
              class="pt-0 pl-1 pr-1"
            >
              <b-form-group
                :label="$t('DEBTIA_VAT_AMOUNT')"
                label-for="title"
              >
                <b-input-group append="kr.">
                  <b-form-input
                    :id="'title-'+index"
                    v-model="item.vatAmount"
                    type="number"
                    :placeholder="$t('DEBTIA_VAT_AMOUNT')"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
              md="6"
              class="pt-0 pl-1 pr-1"
            >
              <b-form-group
                :label="item.amountPaid.status ? $t('DEBTIA_AMOUNT_PAID') + '*' : $t('DEBTIA_AMOUNT_PAID')"
                label-for="item-name"
              >
                <b-input-group
                  append="kr."
                >
                  <b-input-group-prepend is-text>
                    <b-form-checkbox
                      v-model="item.amountPaid.status"
                      name="checkbox-input"
                      class="custom-control-primary"
                      @input="checkboxStatus('amountPaid', item.amountPaid.status, index)"
                    />
                  </b-input-group-prepend>

                  <b-form-input
                    :id="'title-'+index"
                    v-model="item.amountPaid.value"
                    type="number"
                    :placeholder="$t('DEBTIA_AMOUNT_PAID')"
                    :readonly="!item.amountPaid.status"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>

            <!-- Quantity -->
            <b-col
              md="6"
              class="pt-0 pl-1 pr-1"
            >
              <b-form-group
                :label="item.interestRate.status ? $t('DEBTIA_INTEREST_RATE') + '*' : $t('DEBTIA_INTEREST_RATE')"
                label-for="title"
              >
                <b-input-group
                  append="%"
                >
                  <b-input-group-prepend is-text>
                    <b-form-checkbox
                      v-model="item.interestRate.status"
                      name="checkbox-input"
                      class="custom-control-primary"
                      @input="checkboxStatus('interestRate', item.interestRate.status, index)"
                    />
                  </b-input-group-prepend>

                  <b-form-input
                    :id="'title-'+index"
                    v-model="item.interestRate.value"
                    type="number"
                    :placeholder="$t('DEBTIA_INTEREST_RATE')"
                    :readonly="!item.interestRate.status"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <hr>
            </b-col>
          </b-row>
        </b-form>
      </div>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        @click="repeateAgain"
      >
        <feather-icon
          icon="PlusIcon"
          class="mr-25"
        />
        <span>Add New</span>
      </b-button>
    </b-overlay>
  </div>
</template>

<script>
import {
  BOverlay, BRow, BCol, BFormGroup, BButton, BFormFile, BFormCheckbox, BInputGroupPrepend,
  BFormInput,
  BForm,
  BAlert,
  BFormDatepicker,
  BInputGroup,
  BInputGroupAppend,
} from 'bootstrap-vue'
import { required } from '@validations'
import axios from '@axios'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import constants from '@/app-configs/constants'
import Cleave from 'vue-cleave-component'
import i18n from '@/libs/i18n'
import Ripple from 'vue-ripple-directive'
import { EventBus } from '@/event-bus'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us'

export default {
  components: {
    BOverlay,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BFormGroup,
    BFormFile,
    BForm,
    BAlert,
    BFormDatepicker,
    Cleave,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    BInputGroupPrepend,
  },
  directives: {
    Ripple,
  },
  props: {
    caseId: {
      type: [Number, String],
      required: true,
    },
    fileSaved: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      loader: false,
      required,
      errorMsg: '',
      otherFilesIndex: 1,
      items: [
        {
          recordIndex: 1,
          file: [],
          title: '',
          sentAt: '',
          daSentAt: '',
          dueDate: '',
          daDueDate: '',
          dueDateValid: false,
          paymentAmount: '',
          vatAmount: '',
          amountPaid: {
            status: false,
            value: '',
          },
          interestRate: {
            status: false,
            value: '',
          },
        },
      ],
      options: {
        date: {
          date: true,
          delimiter: '-',
          datePattern: ['d', 'm', 'Y'],
        },
      },
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
    this.getCategoryOptions()
  },
  methods: {
    hitme() {
      console.log('i am hit')
    },
    checkboxStatus(type, status, index) {
      if (!status) this.items[index][type].value = ''
    },
    assignDateValue(value, obj, attribute) {
      const parts = value.split('-')
      const day = Number(parts[2])
      const month = Number(parts[1])
      const year = Number(parts[0])
      const formattedDate = `${day < 10 ? '0' : ''}${day}-${month < 10 ? '0' : ''}${month}-${year}`
      // eslint-disable-next-line no-param-reassign
      obj[attribute] = formattedDate
    },
    dueDateValidity(index, item) {
      const compareDate = item.sentAt
      // eslint-disable-next-line no-param-reassign
      item.dueDateValid = false
      if (compareDate && item.dueDate) {
        // eslint-disable-next-line no-param-reassign
        if (this.returnValidateDate(item.dueDate) && this.returnValidateDate(compareDate) && (compareDate < item.dueDate)) {
          // eslint-disable-next-line no-param-reassign
          item.dueDateValid = true
          document.getElementById(`datecomparisonerror-${index}`).style.display = 'none'
        } else {
          document.getElementById(`datecomparisonerror-${index}`).style.display = 'block'
        }
      }
      // this.wizardFieldChange(step, index)
    },
    returnValidateDate(validatingDate) {
      const regex = /^\d{4}-\d{2}-\d{2}$/
      if (regex.test(validatingDate)) {
        return true
      }
      return false
    },
    normalToDa(value) {
      const parts = value.split('-')
      const day = Number(parts[0])
      const month = Number(parts[1])
      const year = Number(parts[2])
      const formattedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`
      return formattedDate
    },
    validateDate(mapId, index, obj, value, daValue) {
      const regex = /^\d{2}-\d{2}-\d{4}$/
      if (!regex.test(obj[value])) {
        document.getElementById(`${mapId}-${index}`).style.display = 'block'
      } else {
        // eslint-disable-next-line no-param-reassign
        obj[daValue] = this.normalToDa(obj[value])
        document.getElementById(`${mapId}-${index}`).style.display = 'none'
      }
    },
    getCategoryOptions() {
      const url = '/settings/file-categories-dropdown'
      axios.get(url).then(response => {
        if (response.status === 200) {
          this.categoryOptions = [{ label: 'Select Category', value: 0 }, ...response.data.data]
          // console.log('options are ', options)
        }
      })
    },
    otherFileFieldChanged(input, index) {
      if (input === 'file') {
        document.getElementById(`file-default-${index}`).nextSibling.style['border-color'] = '#d8d6de'
      } else {
        document.getElementById(`title-${index}`).style['border-color'] = '#d8d6de'
      }
    },
    validateFile(event, index) {
      const file = event.target.files[0]
      if (file) {
        const filetype = file ? file.type : ''
        const filename = file ? file.name : ''
        setTimeout(() => {
          if (!(file
              && ((((filename && filename.includes('.docx'))
                || (filename && filename.includes('.doc'))))
                || (filetype && filetype.includes('pdf'))
                || (filetype && filetype.includes('image/'))))) {
            this.errorMsg = i18n.t('DEBTIA_OTHERFILES_VALIDATION_MESSAGE')
            this.items[index].file = []
          }
        }, 1500)
      }
    },
    repeateAgain() {
      this.otherFilesIndex += 1
      const obj = {
        recordIndex: this.otherFilesIndex,
        file: [],
        title: '',
        sentAt: '',
        daSentAt: '',
        dueDate: '',
        daDueDate: '',
        dueDateValid: false,
        paymentAmount: '',
        vatAmount: '',
        amountPaid: {
          status: false,
          value: '',
        },
        interestRate: {
          status: false,
          value: '',
        },
      }
      this.items.push(obj)
    },
    resetModal() {
      this.otherFilesIndex = 1
      this.errorMsg = ''
      this.items = [
        {
          recordIndex: 1,
          file: [],
          title: '',
          sentAt: '',
          daSentAt: '',
          dueDate: '',
          daDueDate: '',
          dueDateValid: false,
          paymentAmount: '',
          vatAmount: '',
          amountPaid: {
            status: false,
            value: '',
          },
          interestRate: {
            status: false,
            value: '',
          },
        },
      ]
    },
    removeItem(index) {
      this.items.splice(index, 1)
    },
    async submitHandler() {
      // evt.preventDefault()
      let empty = false
      const itemCheckArray = [
        'file',
        'title',
        'sentAt',
        'daSentAt',
        'dueDate',
        'daDueDate',
        'paymentAmount',
        'amountPaid',
        'interestRate',
      ]
      this.items.forEach(element => {
        itemCheckArray.forEach(internalElement => {
          if (!element[internalElement]
            || (internalElement === 'amountPaid' && (element[internalElement].status && !element[internalElement].value))
            || (internalElement === 'interestRate' && (element[internalElement].status && !element[internalElement].value))
          ) {
            this.errorMsg = 'Fill the fields marked with *.'
            empty = true
          }
        })
      })
      if (!empty) {
        this.loader = true
        this.errorMsg = ''
        const arr = []
        const files = []
        const fileIds = []
        this.items.forEach(element => {
          arr.push(element)
          files.push(element.file)
          fileIds.push(element.recordIndex)
        })
        const url = '/save-base-documents'
        const form = new FormData()
        form.append('debt_case_id', this.caseId)
        form.append('data', JSON.stringify(arr))
        form.append('calculate_debt_case', 1)
        fileIds.forEach((index, element) => {
          form.append(`basedocument_${index}`, files[element])
        })
        await axios.post(url, form, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }).then(response => {
          if (response.status === 200) {
            this.errorMsg = ''
            this.loader = false
            this.fileSaved()
            EventBus.$emit('refreshStatmentWidget')
            EventBus.$emit('refreshStatementsAmount')
          }
        }).catch(error => {
          this.errorMsg = error.response.data.message ? error.response.data.message : error.message
        })
      }
    },
  },
}
</script>

    <style lang="scss">
        .scroll-div {
  overflow-y: scroll;
  overflow-x: hidden;
  /* Ensure the inner div doesn't exceed the container */
  max-height: 400px;
  padding-right: 10px;
}
.scroll-div::-webkit-scrollbar {
    width: 12px;
}
.scroll-div::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
}
.scroll-div::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
}
    </style>
